export default "__VITE_ASSET__DH99e5CL__"